import './bootstrap';

import '@modulaire/shared/js/index';
import './cookiebar'
import '@wwdev/cookiebar'
